 

export class MenuItem {
    routeLink: string;
    linkCssClass: string;
    itemCssClass: string;
    text: string;
    type: MenuItemType 
}

export enum MenuItemType {
    Text,
    Image,
    Button
}



export class FaqContent
{
    question: string;
    answer: string;
}
